const STORAGE_KEY = 'table-session-identities';

type IdentityMap = Record<string, string>;

function readIdentities(): IdentityMap {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw) as unknown;
    if (parsed && typeof parsed === 'object') {
      return parsed as IdentityMap;
    }

    return {};
  } catch (error) {
    console.debug('Failed to read session identities', error);
    return {};
  }
}

function writeIdentities(map: IdentityMap): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (error) {
    console.debug('Failed to persist session identities', error);
  }
}

export function getStoredPlayerId(sessionId: string): string | null {
  if (!sessionId) {
    return null;
  }

  const identities = readIdentities();
  return identities[sessionId] ?? null;
}

export function setStoredPlayerId(sessionId: string, playerId: string): void {
  if (!sessionId || !playerId) {
    return;
  }

  const identities = readIdentities();
  identities[sessionId] = playerId;
  writeIdentities(identities);
}
